import React from 'react'

import ScreenContainerSimpleLayoutConnexion from '../ScreenContainerSimpleLayoutConnexion'

interface Props {
  heading: string
  supplementaryAdvice?: string
  supplementaryText: string
  info?: string
  children: React.ReactNode
  connected?: boolean
}

const ConnectionLayout: React.FC<Props> = ({
  heading,
  supplementaryAdvice,
  supplementaryText,
  info,
  children,
  connected,
}: Props) => {
  return (
    <>
      <ScreenContainerSimpleLayoutConnexion isLogged={connected}>
        <div className="layout-connection">
          <div className="top-advice">
            {supplementaryAdvice && <div>{supplementaryAdvice}</div>}
          </div>
          <div className="dialog-box">
            <div className="dialog-box__heading">{heading}</div>
            <div className="dialog-box__complementaryText">
              {supplementaryText}
            </div>
            <p className="dialog-box__info">{info}</p>
            {children}
          </div>
        </div>
      </ScreenContainerSimpleLayoutConnexion>
    </>
  )
}

ConnectionLayout.defaultProps = {
  info: '',
  supplementaryAdvice: '',
  connected: false,
}

export default ConnectionLayout
